// extracted by mini-css-extract-plugin
export default {"horizontal":"_3eI4n","large":"_32l1T","vertical":"_26ybh","bullet":"_3k0pq","a11y":"_1hh2s","a11Y":"_1hh2s"};